import { render } from "./DetailChapter.vue?vue&type=template&id=3fae1eb2&scoped=true"
import script from "./DetailChapter.vue?vue&type=script&lang=js"
export * from "./DetailChapter.vue?vue&type=script&lang=js"

import "./DetailChapter.vue?vue&type=style&index=0&id=3fae1eb2&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fae1eb2"]])

export default __exports__